import { render } from "./NameSetterModal.vue?vue&type=template&id=4a3f6dd9&scoped=true"
import script from "./NameSetterModal.vue?vue&type=script&lang=js"
export * from "./NameSetterModal.vue?vue&type=script&lang=js"

import "./NameSetterModal.vue?vue&type=style&index=0&id=4a3f6dd9&lang=css"
import "./NameSetterModal.vue?vue&type=style&index=1&id=4a3f6dd9&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4a3f6dd9"

export default script